(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');
    module.directive('quickSidebarClose', [QuickSidebarCloseFn]);

    /* main quick sidebar close directive */
    function QuickSidebarCloseFn() {
        var directive = {
            restrict: 'A',
            link: link
        };
        return directive;

        // linker
        function link(scope, element) {
            // body element
            var body = document.body;
            // quick sidebar toggler (METRONIC)
            element.on("click", function (e) {
                body.classList.remove('page-quick-sidebar-open');

                // show scroll-bar
                body.style.overflowY = 'auto';
            });

            // destroy
            scope.$on("$destroy", function () {
                element.off("click");
            });

        } // link

    }

})();